module.exports = __webpack_public_path__ + "img/bear.cc44a0f2.svg";